"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipTrigger = exports.TooltipPopper = exports.TooltipContentWrapper = exports.TooltipContent = exports.Tooltip = exports.CloseButtonWrapper = exports.CloseButton = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _LexusTypography = require("../../../components/LexusTypography");
const fadeIn = (0, _styledComponents.keyframes)`
from {
  opacity: 0;
}
to {
  opacity: 1;
}
`;
const Tooltip = exports.Tooltip = _styledComponents.default.span`
  position: relative;
`;
const TooltipPopper = exports.TooltipPopper = _styledComponents.default.div`
  @media (prefers-reduced-motion: no-preference) {
    animation-name: ${fadeIn};
    animation-fill-mode: backwards;
    animation-duration: 100ms;
  }
`;
const TooltipTrigger = exports.TooltipTrigger = _styledComponents.default.button`
  background: none;
  border: none;
  padding: 0px;
  cursor: pointer;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: 1;
`;
const TooltipContentWrapper = exports.TooltipContentWrapper = _styledComponents.default.div`
  position: relative;
  background: #000;
  padding: 10px;
  padding-right: 35px;
  --overflow-max-height: 175px;
  --overflow-max-width: 225px;
`;
const TooltipContent = exports.TooltipContent = _styledComponents.default.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  color: #FFF;
  
  
  ${(0, _LexusTypography.nobel)({
  sizing: "body14"
})}
  
  span {
    display: block;
    margin: 10px 0;
  }
  span:first-child {
    margin-top: 0;
  }
  span:last-child {
    margin-bottom: 0;
  }
`;
const CloseButtonWrapper = exports.CloseButtonWrapper = _styledComponents.default.div`
  position: absolute;
  right: 5px;
  top: 5px;
`;
const CloseButton = exports.CloseButton = _styledComponents.default.button`
  background: none;
  border: none;
  color: #fff;
  padding: 5px;
  cursor: pointer;
  width: 25px;

  svg {
    fill: #fff;
  }
`;